/**
 * Inline-style helper. tokens.css içindeki CSS değişkenlerini referans
 * alarak `element.style.cssText`'i set eder. Mevcut sayfalardaki inline
 * style pattern'iyle uyumlu — yeni komponentler aynı yolu kullansın.
 */
function kebab(key) {
    return key.replace(/[A-Z]/g, c => '-' + c.toLowerCase());
}
export function applyStyle(el, style) {
    const parts = [];
    for (const [k, v] of Object.entries(style)) {
        if (v === undefined || v === null)
            continue;
        parts.push(`${kebab(k)}: ${v}`);
    }
    el.style.cssText = parts.join('; ');
}
export function el(tag, options) {
    const node = document.createElement(tag);
    if (options?.className)
        node.className = options.className;
    if (options?.text !== undefined)
        node.textContent = options.text;
    if (options?.html !== undefined)
        node.innerHTML = options.html;
    if (options?.attrs) {
        for (const [k, v] of Object.entries(options.attrs))
            node.setAttribute(k, v);
    }
    if (options?.style)
        applyStyle(node, options.style);
    if (options?.children) {
        for (const c of options.children) {
            if (typeof c === 'string')
                node.append(c);
            else
                node.append(c);
        }
    }
    return node;
}
/** HTML escape — innerHTML üzerinden user-input renderlerken zorunlu. */
export function escapeHtml(s) {
    return s.replace(/[&<>"']/g, c => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;',
        '"': '&quot;', "'": '&#39;',
    }[c]));
}
